<script>
  import Brand from "./Brand.svelte";
  let mbox;
  let active = false;
  export let name;

  function handleMessage(event) {
    console.log(event.detail.key);
    active = event.detail.key;
  }

  function deactivate() {
    active = false;
  }

  const initModuloBox = () => {
    mbox = new window.ModuloBox({
      mediaSelector: '.mbox',
    });
    console.log(mbox);
    mbox.init();
  }

  let data = {
    brands: [
      {
        order: 0,
        key:"seaport",
        brand: "Sea Port",
        description:"Sea Port® has a reputation for quality, versatility, consistency, ongoing relationships and competitive pricing. Sea Port® brand offers the widest selection of products. If you like the ease of buying with just one call, one stop, one name you can trust, let Sea Port be the brand to fill your freezer.",
        sections:[
          {
            key:"seaport-retail",
            category:"Products",
            products:[
              {order: 0, key:"seaport_bag_whiteshrimp_rawezpeel_10lb",       name:"1.0lb White Shrimp Raw EZ-Peel"},
              {order: 1, key:"seaport_bag_whiteshrimp_rawezpeel_20lb",       name:"2.0lb White Shrimp Raw EZ-Peel"},
              {order: 2, key:"seaport_box_whiteshrimp_headlessshellon_40lb", name:"4.0lb White Shrimp Headless, Shell-On"},
              {order: 3, key:"seaport_bag_whiteshrimp_rawtailoff_10lb",      name:"1.0lb White Shrimp Raw Tail-Off"},
              {order: 4, key:"seaport_bag_whiteshrimp_rawtailoff_20lb",      name:"2.0lb White Shrimp Raw Tail-Off"},
              {order: 5, key:"seaport_bag_whiteshrimp_rawtailon_10lb",       name:"1.0lb White Shrimp Raw Tail-On"},
              {order: 6, key:"seaport_bag_whiteshrimp_rawtailon_20lb",       name:"2.0lb White Shrimp Raw Tail-On"},
              {order: 7, key:"seaport_bag_whiteshrimp_cookedezpeel_20lb",    name:"2.0lb White Shrimp Cooked EZ-Peel"},
              {order: 8, key:"seaport_bag_whiteshrimp_cookedtailoff_10lb",   name:"1.0lb White Shrimp Cooked Tail-Off"},
              {order: 9, key:"seaport_bag_whiteshrimp_cookedtailoff_20lb",   name:"2.0lb White Shrimp Cooked Tail-Off"},
              {order: 10, key:"seaport_bag_whiteshrimp_cookedtailon_10lb",    name:"1.0lb White Shrimp Cooked Tail-On"},
              {order: 11, key:"seaport_bag_whiteshrimp_cookedtailon_20lb",    name:"2.0lb White Shrimp Cooked Tail-On"},
              {order: 12, key:"seaport_bag_blacktigerprawns_rawtailon_20lb", name:"2.0lb Black Tiger Prawns, Raw, Tail-On"},
              {order: 13, key:"seaport_bag_blacktigerprawns_rawtailoff_20lb", name:"2.0lb Black Tiger Prawns, Raw, Tail-Off"},
              {order: 14, key:"seaport_bag_blacktigerprawns_cookedtailon_20lb", name:"2.0lb Black Tiger Prawns, Cooked, Tail-On"},
              {order: 15, key:"seaport_bag_blacktigerprawns_cookedtailoff_20lb", name:"2.0lb Black Tiger Prawns, Cooked, Tail-Off"},
              {order: 16, key:"seaport_box_blacktigerprawns_headlessshellon", name:"Black Tiger Prawns Headless, Shell-On"},
              {order: 17, key:"seaport_box_blacktigerprawns_headonshellon",   name:"Black Tiger Prawns Head-On, Shell-On"},
              {order: 18, key:"seaport_box_freshwatershrimp",                 name:"Freshwater Shrimp"},
              {order: 19, key:"seaport_bag_freshwatershrimp_rawezpeel_20lb",  name:"2.0lb Freshwater Shrimp  Raw EZ-Peel"},
              {order: 20, key:"seaport_bag_greenshellmussels",                name:"Greenshell Mussels"},
              {order: 21, key:"seaport_box_greenshellmussels",                name:"Greenshell Mussels"},
              {order: 22, key:"seaport_bag_imitationcrabflakes_10lb",         name:"1.0lb Imitation Crab Flakes"},
              {order: 23, key:"seaport_bag_imitationcrabflakes_25lb",         name:"2.5lb Imitation Crab Flakes"},
              {order: 24, key:"seaport_bag_imitationcrabsticks_10lb",         name:"1.0lb Imitation Crab Sticks"},
              {order: 25, key:"seaport_bag_imitationcrabsticks_25lb",         name:"2.5lb Imitation Crab Sticks"},
              {order: 26, key:"seaport_bag_marinaramix",                      name:"Marinara Mix"},
              {order: 27, key:"seaport_box_calamaristeak",                    name:"Calamari Steak"},
              {order: 28, key:"seaport_box_squid",                            name:"Squid"},
              {order: 29, key:"seaport_box_snowcrab",                         name:"Snow Crab"},
              {order: 30, key:"seaport_label_langostino",                     name:"Langostino"},

            ]
          },
        ]
      },
      {
        order: 1,
        key:"cnami",
        brand: "Cnami",
        description:"The Cnami® brand features seafood products that will satisfy your Asian seafood needs. Our current product line includes Tobiko, Eel, Seaweed Salad, Seasoned Squid Salad, and Tilapia.",
        sections:[
          {
            key:"cnami-retail",
            category:"Products",
            products:[
              {order: 1, key:"cnami_bag_tilapia_5oz",         name:"5-7oz Tilapia"},
              {order: 1, key:"cnami_bag_tilapia_7oz",         name:"7-9oz Tilapia"},
              {order: 1, key:"cnami_bag_tilapia_9oz",         name:"9oz+ Tilapia"},
              {order: 2, key:"cnami_label_squidsalad",    name:"Squid Salad"},
              {order: 3, key:"cnami_label_tobiko_black",  name:"Tobiko Black"},
              {order: 4, key:"cnami_label_tobiko_green",  name:"Tobiko Green"},
              {order: 5, key:"cnami_label_tobiko_orange", name:"Tobiko Orange"},
              {order: 6, key:"cnami_label_tobiko_red",    name:"Tobiko Red"},
              {order: 7, key:"cnami_label_unagi_8oz",     name:"8oz Unagi"},
              {order: 8, key:"cnami_label_unagi_9oz",     name:"9oz Unagi"},
              {order: 9, key:"cnami_label_unagi_10oz",    name:"10oz Unagi"},
              {order: 10, key:"cnami_label_wakame_10lb",   name:"1.0lb Wakame"},
              {order: 11, key:"cnami_label_wakame_44lb",   name:"4.4lb Wakame"},
            ]
          },
        ]
      },
      {
        order: 1,
        key:"ola",
        brand: "Ola!",
        description:"Discover OLA!® brand. “Ola” means “wave” in Spanish, and we created this brand to have a bold, bright, colorful appeal as well as to highlight some of the versatile ways seafood can be served. All packaging in OLA! brand includes product information in both English and Spanish.",
        sections:[
          {
            key:"ola-retail",
            category:"",
            products:[
              {order: 1, key:"ola_bag_mahimahi_6oz", name:"6oz Mahi Mahi"},
              {order: 2, key:"ola_bag_mahimahi_8oz", name:"8oz Mahi Mahi"},
              {order: 3, key:"ola_bag_mahimahi_10oz", name:"10oz Mahi Mahi"},
            ]
          },
        ]
      },
    ]
  };

</script>

<svelte:head>
  <link rel="stylesheet" href="/script/modulobox.min.css" media="screen">
  <script src="/script/modulobox.min.js" on:load={initModuloBox}></script>
</svelte:head>

<header class={`${active ? "is-active" : ""}`} on:click={deactivate}>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <rect fill="currentColor" x="16" y="30" width="32" height="4" transform="rotate(45 32 32)" />
    <rect fill="currentColor" x="16" y="30" width="32" height="4" transform="rotate(135 32 32)" />
  </svg>

</header>
<main>
  {#if !active }<h1 class="title">Click on each brand to view packages</h1>{/if}
  <div class="main-brands">
    {#each data.brands as brand}
    <Brand
      brand={brand}
      active={active === brand.key ? true : false}
      mode={!active}
      on:message={handleMessage}
      mbox={mbox}
    />
  {/each}
  </div>
</main>
<footer>
  <img class="small-logo" alt="Sea Port Products Corporation" src="/images/footer.svg"/>
  <a class="footer-link" href="http://cport.net">www.cport.net</a>
  <address class="address">
    Kirkland, WA 98033 | ph: (425) 827-2800 | email: sales@cport.net
  </address>
</footer>

<style>
  :global(body) {
    margin: 0;
    padding: 0;
    background-color: #003DA6;
    color: white;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    font-family: "Open Sans", sans-serif;
  }
  header {
    position: fixed;
    top: 8px;
    right: 8px;
    width: 64px;
    height: 64px;
    overflow: hidden;
    display: none;
  }
  header.is-active {
    display: block;
  }
  header svg {
    filter: drop-shadow(0px 0px 4px #003da6);
  }
  main {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
  }
  .title {
    text-align: center;
    padding-inline: 24px;
    padding-block: 24px;
  }
  .main-brands {
    flex-direction: column;
    justify-content: space-around;
    align-items: stretch;
  }
  @media (orientation: landscape) {
    .main-brands {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
  footer {
    flex-grow: 0;
    padding: 8px;
    margin-top: 48px;
    text-align: center;
  }
  .small-logo {
    display: block;
    margin: 0 auto;
    max-width: calc(100% - 16px);
    width: 420px;
  }
  .footer-link {
    margin-bottom: 16px;
    display: block;
    color: white;
    font-weight: bold;
  }
  .address {
    font-style: normal;
    margin-bottom: 64px;
  }
</style>
